import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent } from "@/components/ui/card";

/** Tab "Dados do Caso" — date/time/duration/bed/procedures/status/diagnosis/notes/competence. */
export default function DadosTab({
  cs, edit, setEdit, procs, statuses,
  changeReason, setChangeReason,
  addProcedure, removeProcedure, savePayload,
}) {
  const procIds = edit.procedure_ids || (edit.procedure_id ? [edit.procedure_id] : []);
  return (
    <Card><CardContent className="p-6 grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="space-y-1.5"><Label>Data</Label>
        <Input type="date" value={edit.surgery_date || ""} onChange={(e) => setEdit({ ...edit, surgery_date: e.target.value })} /></div>
      <div className="space-y-1.5"><Label>Hora</Label>
        <Input value={edit.surgery_time || ""} onChange={(e) => setEdit({ ...edit, surgery_time: e.target.value })} /></div>
      <div className="space-y-1.5"><Label>Duração</Label>
        <Input value={edit.estimated_duration || ""} onChange={(e) => setEdit({ ...edit, estimated_duration: e.target.value })} /></div>
      <div className="space-y-1.5"><Label>Leito</Label>
        <Input value={edit.bed || ""} onChange={(e) => setEdit({ ...edit, bed: e.target.value })} /></div>

      <div className="md:col-span-3 space-y-1.5">
        <Label>Procedimentos (múltiplos suportados)</Label>
        <div className="space-y-2">
          {procIds.length === 0 && (
            <div className="text-xs text-slate-400 italic">Nenhum procedimento vinculado</div>
          )}
          {procIds.map((pid, idx) => {
            const p = procs.find((x) => x.id === pid);
            return (
              <div key={pid} className="flex items-center gap-2 p-2 border border-slate-200 rounded-md bg-slate-50" data-testid={`proc-row-${idx}`}>
                <span className="text-[10px] uppercase tracking-wider text-slate-500 font-medium w-14">{idx === 0 ? "Principal" : `Adic. ${idx}`}</span>
                <span className="flex-1 text-sm font-medium text-slate-900">{p?.name || "(procedimento removido)"}</span>
                <span className="text-xs text-slate-500">SUS {p?.sus_code || "—"}</span>
                <Button size="sm" variant="ghost" className="text-red-600 hover:bg-red-50" onClick={() => removeProcedure(pid)} data-testid={`btn-remove-proc-${idx}`}>Remover</Button>
              </div>
            );
          })}
          {(cs.unrecognized_procedures || []).length > 0 && (
            <div className="text-xs p-2 rounded-md bg-amber-50 text-amber-800 border border-amber-200">
              Procedimento(s) não cadastrado(s) detectado(s) no mapa: <strong>{cs.unrecognized_procedures.join(", ")}</strong>.
              Cadastre em <em>Procedimentos</em> e adicione abaixo.
            </div>
          )}
          <div className="flex items-center gap-2">
            <select className="flex-1 border border-slate-300 rounded-md px-3 h-11 md:h-9 text-base md:text-sm bg-white min-h-[44px]"
              value=""
              onChange={(e) => { addProcedure(e.target.value); e.target.value = ""; }}
              data-testid="select-add-procedure">
              <option value="">+ Adicionar procedimento</option>
              {procs
                .filter((p) => !procIds.includes(p.id))
                .map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </div>
        </div>
      </div>

      <div className="space-y-1.5"><Label>Status</Label>
        <select className="w-full border border-slate-300 rounded-md px-3 h-11 md:h-9 text-base md:text-sm bg-white min-h-[44px]"
          value={edit.status || ""} onChange={(e) => setEdit({ ...edit, status: e.target.value })}>
          {statuses.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
        </select>
      </div>
      <div className="md:col-span-3 space-y-1.5"><Label>Diagnóstico</Label>
        <Textarea rows={3} value={edit.diagnosis || ""} onChange={(e) => setEdit({ ...edit, diagnosis: e.target.value })} /></div>
      <div className="md:col-span-3 space-y-1.5"><Label>Observações</Label>
        <Textarea rows={3} value={edit.notes || ""} onChange={(e) => setEdit({ ...edit, notes: e.target.value })} /></div>
      <div className="md:col-span-3 space-y-1.5"><Label>Competência de faturamento (AAAA-MM)</Label>
        <Input value={edit.billing_competence || ""} onChange={(e) => setEdit({ ...edit, billing_competence: e.target.value })} placeholder="2026-04" /></div>
      <div className="md:col-span-3">
        <label className="inline-flex items-center gap-2 cursor-pointer p-3 rounded-md border border-emerald-200 bg-emerald-50/50 hover:bg-emerald-50" data-testid="case-pro-bono-toggle-wrap">
          <input
            type="checkbox"
            checked={!!edit.pro_bono}
            onChange={(e) => setEdit({ ...edit, pro_bono: e.target.checked })}
            data-testid="case-pro-bono-toggle"
          />
          <span className="text-sm">
            <span className="font-semibold text-emerald-900">❤️ Cirurgia pro bono</span>
            <span className="block text-xs text-slate-600">
              Conta na produção (total + pro bono), mas <strong>NÃO gera faturamento</strong> nem efeito financeiro.
            </span>
          </span>
        </label>
      </div>
      <div className="md:col-span-3 space-y-1.5"><Label>Motivo da alteração (opcional, vira auditoria)</Label>
        <Input value={changeReason} onChange={(e) => setChangeReason(e.target.value)} /></div>
      <div className="md:col-span-3">
        <Button onClick={savePayload} className="bg-blue-700 hover:bg-blue-800 h-11 md:h-9 w-full sm:w-auto" data-testid="btn-save-case">Salvar</Button>
      </div>
    </CardContent></Card>
  );
}
